import React from "react";
import Modal from "../../../../shared/components/Modal/Modal";
import "./XpPointsInfoModal.css";

function getXpValue(rule) {
  if (rule?.xp != null && rule?.xp !== "") {
    const value = String(rule.xp).trim();
    return value.startsWith("+") ? `${value} XP` : `+${value} XP`;
  }
  const match = String(rule?.description || "").match(/\+\d+\s*XP/i);
  return match ? match[0].replace(/\s+/g, " ") : "";
}

function XpPointsInfoModal({ isOpen, onClose, popupData }) {
  if (!popupData) return null;

  const participationText =
    popupData?.participation?.items?.[0] ||
    popupData?.participation?.description ||
    "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeAboveModal
      stackClassName="xp-info-modal__dialog-stack"
      width="460px"
      height="auto"
      borderRadius="12px"
      padding="10px 20px"
      marginTop="0"
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      textAlign="left"
    >
      <div className="xp-info-modal">
        <h3 className="xp-info-modal__title">{popupData?.title}</h3>
        <p className="xp-info-modal__intro">{popupData?.intro}</p>

        <div className="xp-info-modal__cards">
          {(popupData?.rules || []).map((rule, idx) => (
            <div
              key={`${rule?.label || "rule"}-${idx}`}
              className="xp-info-modal__card"
            >
              <div className="xp-info-modal__card-text">
                <span className="xp-info-modal__card-title">{rule?.label}</span>
                <span className="xp-info-modal__card-subtitle">Correct answer earns</span>
              </div>
              <span className="xp-info-modal__xp-value">{getXpValue(rule)}</span>
            </div>
          ))}
        </div>

        <div className="xp-info-modal__participation">
          <span className="xp-info-modal__participation-title">
            {popupData?.participation?.heading
              ? popupData.participation.heading.replace(/:$/, "").toUpperCase()
              : "PARTICIPATION REWARD"}
          </span>
          <p className="xp-info-modal__participation-text">{participationText}</p>
        </div>

        <p className="xp-info-modal__footer">{popupData?.footer_message}</p>
      </div>
    </Modal>
  );
}

export default XpPointsInfoModal;
